'use client';

import React from 'react';

import { HtmlInterface } from '~/payload-types';

type HtmlBlockProps = HtmlInterface & {};

const HtmlBlock = (props: HtmlBlockProps) => {
  if (!props.html) return null;

  return <div dangerouslySetInnerHTML={{ __html: props.html }} />;
};

export default HtmlBlock;
